var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValolytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1185.898299828485,
    height: 1185.898299828485,
    viewBox: "68.732936351611 -18.949149914242 1185.898299828485 1185.898299828485",
    fill: "none",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Gradient V logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "A vector reconstruction of the supplied logo, with overlapping pink, coral, violet, and blue ribbons on a transparent background.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink",
    gradientUnits: "userSpaceOnUse",
    x1: 113.13,
    y1: 48.53,
    x2: 543.13,
    y2: 232.97
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63ba5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16667,
    stopColor: "#e63ca4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33333,
    stopColor: "#e73ca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e83ca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66667,
    stopColor: "#e83ca2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83333,
    stopColor: "#e83ca2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e73ca1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coral",
    gradientUnits: "userSpaceOnUse",
    x1: 253.63,
    y1: 384.12,
    x2: 467.3,
    y2: 707.74
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc4d54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16667,
    stopColor: "#fc4e56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33333,
    stopColor: "#fb4e56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fb4d56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66667,
    stopColor: "#fa4c58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83333,
    stopColor: "#f94c5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9485e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "overlap",
    gradientUnits: "userSpaceOnUse",
    x1: 293.15,
    y1: 482.19,
    x2: 536.75,
    y2: 882.87
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf46b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16667,
    stopColor: "#bf47b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33333,
    stopColor: "#bd47ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ba48bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66667,
    stopColor: "#b548c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83333,
    stopColor: "#b148c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ac49cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blue",
    gradientUnits: "userSpaceOnUse",
    x1: 385.49,
    y1: 577.92,
    x2: 717.49,
    y2: 1075.65
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#664ff5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16667,
    stopColor: "#6453f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33333,
    stopColor: "#5b5afa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4f63fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66667,
    stopColor: "#406efc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83333,
    stopColor: "#2f78fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f80fc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "silhouette",
    d: "M110 78 H364.595461792 C382.595461792 78 398.114692561 89 406.595461792 106 L482.119348824951 257.390286025235 L561.743103078414 103 C569.994788471673 87 584.743103078414 78 603.743103078414 78 H1213 C1245 78 1265 110 1249 143 L790 1033 C779 1056 759 1070 733 1070 H575 C550 1070 531 1059 519 1036 L78 152 C59 116 69 78 110 78 Z"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-clip"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#silhouette"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo-clip)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#violet)",
    d: "M0 0 H1318 V1193 H0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#blue)",
    d: "M0 0 H1318 V1193 H595.150452 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#pink)",
    d: "M0 0 H482.119348824951 V257.390286025235 L656.149797755 606.240437622 L475.42370806 956.667931802 H0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#overlap)",
    d: "M301.3932591297 607.817780205567 L482.119348824951 257.390286025235 L656.149797755 606.240437622 L475.42370806 956.667931802 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#coral)",
    d: "M482.119348824951 257.390286025235 L614.863327797515 0 H968.806383 L656.149797755 606.240437622 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValolytics);
export default __webpack_public_path__ + "static/media/valolytics.cbc66558a9e3f4c8e9b09faa33738752.svg";
export { ForwardRef as ReactComponent };